export const isType = (type, value) => Object.prototype
  .toString
  .call(value)
  .toLowerCase()
  .replace('[object', '')
  .includes(type);

